var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodybattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.3069V13.0837C0.5 12.594 0.633 12.1405 0.899 11.7232C1.165 11.3058 1.5205 10.985 1.9655 10.7607C2.95383 10.2762 3.95092 9.91274 4.95675 9.67041C5.96258 9.42807 6.977 9.30691 8 9.30691C8.391 9.30691 8.782 9.32657 9.173 9.36591C9.56417 9.40541 9.95525 9.46457 10.3462 9.54341V15.3069H0.5ZM8 7.69141C7.0375 7.69141 6.21358 7.34874 5.52825 6.66341C4.84275 5.97791 4.5 5.15391 4.5 4.19141C4.5 3.22891 4.84275 2.40499 5.52825 1.71966C6.21358 1.03416 7.0375 0.691406 8 0.691406C8.9625 0.691406 9.78642 1.03416 10.4718 1.71966C11.1573 2.40499 11.5 3.22891 11.5 4.19141C11.5 5.15391 11.1573 5.97791 10.4718 6.66341C9.78642 7.34874 8.9625 7.69141 8 7.69141ZM14.25 19.0567V14.6529H12.5385V9.24916H17.596L15.6827 13.0569H17.5673L14.25 19.0567Z",
    fill: "#1780EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodybattery);
export default __webpack_public_path__ + "static/media/Bodybattery.89b0f398fd28a0899df6e39485f47da1.svg";
export { ForwardRef as ReactComponent };